import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Link, Typography } from '@mui/material';
import { type DriverType } from '@repo/supergraph/marketplace/types';
import { DisclosureTooltip } from '@repo/ui/DisclosureTooltip';
import React from 'react';

export const DriverCell = ({ driver }: { driver?: DriverType }): React.JSX.Element => {
  const renderValue = ({ driver }: { driver?: DriverType }) => {
    if (!driver?.value && driver?.label === 'Overdraft star rating') {
      return 'Not rated yet';
    }
    if (!driver || !driver?.value) {
      return 'N/A';
    }
    if (driver.label === 'Product type') {
      return driver.value;
    }

    return driver.value?.replace('-', ' -\n');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ lineHeight: '24px' }}>
        <Typography display="inline" variant="text">
          {renderValue({ driver })}
        </Typography>
        {driver?.valueTooltip && (
          <Box component="span" display="inline" whiteSpace="nowrap">
            &nbsp;
            <DisclosureTooltip
              trigger={
                <Link aria-label={`${driver.label} info`} component="button" color="text.primary">
                  <HelpOutlineIcon />
                </Link>
              }
            >
              <Typography variant="textSmall">{driver.valueTooltip}</Typography>
            </DisclosureTooltip>
          </Box>
        )}
      </Box>
      <Box>
        {driver?.description && (
          <Typography variant="textSmall" sx={{ color: 'text.secondary' }}>
            {driver.description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
